/**
 * Runs of commits that nothing points at (see `Git.Repository.danglingCommits()`) are removed
 * this many days after upload, even when the project's data retention is longer. Most of them
 * test pull request merge commits that a later push or a force-push has replaced.
 */
export const DANGLING_RUNS_RETENTION_DAYS = 14;
